import React, { useEffect, useState } from "react";
import { Text, StyleSheet, View, Platform } from "react-native";
import { uniqueId } from "lodash";

import { hasItems, navigate } from "../../../../../helpers/utils";
import cardStyles from "../cardStyles";
import CloseIcon from "../../../common/dialog/CloseIcon";
import appPages from "../../../../../appPages";
import OperationIcon from "../../../common/ActionsMenuButton/icons/OperationIcon";
import IntegrationWrapper from "../../../integrations/details/IntegrationWrapper";
import IntegrationsHelper, {
  INTEGRATION_KEYS,
} from "../../../integrations/IntegrationsHelper";
import AppTheme from "../../../AppTheme";
import ElementItem from "../../../elements/list/ElementItem";
import ManaButton from "../../../common/ManaButton";
import CardUtils from "../CardUtils";

export default function IntegrationMappingCard({ controller, data = {} }) {
  if (!controller.state.elements) return null;

  const cardUtils = new CardUtils(controller, data, setShowCard);
  const [integration, setIntegration] = useState(data.integration);
  const [elements, setElements] = useState(data.elements);
  const [showCard, setShowCard] = useState(false);

  const DEBUG = controller.state?.settings?.show_admin_tools;

  // ------------------------------------- DUMMY DATA -------------------------------------
  const dummyIntegration = {
    eventName: `Product Weekly ${uniqueId()}`,
    calendarName: "Joe Boeing",
    attendees: [{}, {}, {}],
    source: {
      name: INTEGRATION_KEYS.google,
      startTime: "2021-06-01 9:00 am",
      endTime: "2021-06-01 10:00 am",
    },
  };

  const dummyElement = {
    color: "#243251",
    icon: "1f420",
    id: "22472",
    is_active: 1,
    is_core: 0,
    is_favorite: 1,
    is_major: 1,
    is_owner: 1,
    is_shared: 0,
    name: "Work",
    tracked_time: "Mar 4, 2021, 7:04:32 AM",
    tracked_duration: 60,
  };
  // ------------------------------------- METHODS -------------------------------------
  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  const fetchCardData = () => {
    if (DEBUG) {
      setIntegration(dummyIntegration);
      setElements([dummyElement]);
      return;
    }

    const action = {
      action: "get-integration-mapping-card",
    };

    controller.apiService.cardAction(action).then((data) => {
      if (data.integration) {
        setIntegration(data.integration);
        setElements(data.elements);
      } else {
        setShowCard(false);
      }
    });
  };

  const saveMapping = (element) => {
    const operator = "match";
    const discriminator = "";

    IntegrationsHelper.mapIntegrationToElement(
      controller,
      {
        operator,
        discriminator,
        integration,
        element,
      },
      () => {
        navigate(controller, appPages.integrationsMappingDone, "changePage", {
          integration,
        });
      },
    );
  };

  const goToMappingPage = (skip) => {
    // 2021.11.09: specs changed: skip now refreshes card content
    navigate(controller, appPages.integrationsMappingGame, "changePage", {
      //skipActivity: skip,
      integration,
    });
  };

  return !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 98, height: "auto" }]}>
        <CloseIcon
          onPress={cardUtils.closeCard}
          style={cardStyles.closeButton}
        />

        <View style={[cardStyles.header, { paddingHorizontal: 0 }]}>
          <OperationIcon />

          <View style={[cardStyles.headerInfo, { marginLeft: 6 }]}>
            <Text style={cardStyles.title}>
              Which Element fits this activity best?
            </Text>
          </View>
        </View>

        <View style={styles.content}>
          <View
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {integration ? (
              <View style={styles.section}>
                <IntegrationWrapper
                  controller={controller}
                  data={integration}
                  highlight
                  style={{
                    minHeight: 40,
                    paddingLeft: 16,
                    paddingRight: 14,
                    paddingBottom: 0,
                    marginBottom: 0,
                  }}
                />
              </View>
            ) : null}

            {!hasItems(elements) ? null : (
              <View style={styles.section}>
                {elements.map((elem) => (
                  <ElementItem
                    key={"intMapCardEl" + elem.id}
                    item={elem}
                    controller={controller}
                    onElementSelected={() => saveMapping(elem)}
                    hideActions
                    noIcons
                  />
                ))}
              </View>
            )}

            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                height: 40,
              }}
            >
              <ManaButton
                text={"Skip this Activity"}
                style={[styles.button, { marginRight: 6 }]}
                styleText={styles.buttonText}
                onPress={fetchCardData}
              />

              <ManaButton
                isMainButton
                text={"Select Different Element"}
                style={[styles.button, { flex: 1 }]}
                styleText={styles.buttonText}
                onPress={goToMappingPage}
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {},
  section: {
    borderBottomColor: AppTheme.borderColor,
    borderBottomWidth: 1,
  },
  button: {
    width: "40%",
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
